import { Link } from "react-router-dom";
import { LOGO_ALT, LOGO_SRC } from "@/lib/brand";
import { useSettings } from "@/context/SettingsContext";

const SIZES = { header: "h-12 sm:h-14", footer: "h-24 sm:h-28", admin: "h-20" };

export const Logo = ({ light = false, to = "/", testId = "header-logo", size = "header" }) => {
  const src = useSettings().logo_url || LOGO_SRC;
  return (
    <Link to={to} data-testid={testId} className="group inline-flex flex-col leading-none">
      {src ? (
        <img src={src} alt={LOGO_ALT} data-testid={`${testId}-image`} className={`${SIZES[size]} w-auto object-contain`} />
      ) : (
        <TypeLogo light={light} compact={size === "admin"} />
      )}
    </Link>
  );
};

const TypeLogo = ({ light, compact }) => (
  <>
    <span className={`font-serif font-semibold tracking-[0.12em] ${compact ? "text-xl" : "text-2xl sm:text-[1.7rem]"} ${light ? "text-[#F5F0E8]" : "text-[#39251D]"}`}>
      BDC<span className="text-[#956842] mx-0.5">·</span>BOUTIQUE
    </span>
    <span className={`font-serif italic text-[0.8rem] sm:text-sm tracking-wide mt-0.5 ${light ? "text-[#D5B98C]" : "text-[#956842]"}`}>
      by La Bottega del Calzolaio
    </span>
  </>
);

export const DemoBadge = ({ className = "", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.2em] bg-[#242321]/85 text-[#F5F0E8] ${className}`}
  >
    Demo
  </span>
);

export const UniqueBadge = ({ className = "", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 font-serif italic text-[13px] leading-none bg-[#F5F0E8] text-[#39251D] border border-[#956842]/60 shadow-[0_2px_8px_-4px_rgba(57,37,29,.4)] ${className}`}
  >
    <span className="w-1 h-1 rounded-full bg-[#956842]" />Pezzo unico
  </span>
);
